<template>
<div class="l-container-content bg-white">
    <div class="row">
        <div class="col-6">
            <h3>All Users</h3>
        </div>
        <div class="col-6 text-right">
            <router-link :to="{name: 'addUser'}" class="button primary">Add User</router-link>
        </div>
    </div>
    <div class="row">
        <loader v-show="loading" />
        <vuetable ref="vuetable" :http-options="httpOptions" :api-url="url" :fields="columns" :sort-order="sortOrder" track-by="msisdn" :append-params="moreParams" :per-page="10" @vuetable:pagination-data="onPaginationData" @vuetable:loading="onLoading" @vuetable:loaded="onLoaded">
            <div slot="fullname" slot-scope="props">
                {{props.rowData.first_name}} {{props.rowData.middle_name}}

            </div>

        </vuetable>
        </div>
        
        <div class="vuetable-pagination ui basic segment grid row">
            <div class="col text-left">
                <vuetable-pagination-info ref="paginationInfo"></vuetable-pagination-info>
            </div>
            
            <div class="col-6  text-right">
                <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage"></vuetable-pagination>
            </div>
            
        </div>

</div>
</template>

<style>
td.vuetable-slot {
    overflow: visible !important;
}
</style>

<script>
import Vuetable from "vuetable-2/src/components/Vuetable";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import VuetablePaginationInfo from "vuetable-2/src/components/VuetablePaginationInfo";
import loader from "@/components/loader";

export default {
    components: {
        Vuetable,
        VuetablePagination,
        VuetablePaginationInfo,
        loader
    },
    name: "approvals",

    data() {
        return {
            loading: true,
            loadRecord: false,
            selected_data: {},
            url: "https://interactiveapi.chezagame.com/portal/v1/view/system/user",
            httpOptions: {
                headers: {
                    'X-App-Key': '09lib74145Qb3HO6eQTIfsbylRkyuZFT',
                    'X-Authorization-Key': 'ADMIN_APP',
                    'X-Requested-With': 'XMLHttpRequest',
                    'X-Token-Key': this.$cookies.get("accessToken")
                }
            },
            columns: [{
                    name: "fullname",
                    title: '<span class="orange glyphicon glyphicon-user"></span> Name',
                    sortField: "fullname",
                    titleClass: "center aligned",
                    dataClass: "center aligned"
                },

                {
                    name: "mobile_number",
                    title: "Phone",
                    sortField: "mobile_number",
                    titleClass: "",
                    dataClass: ""
                },
                {
                    name: "email_address",
                    title: "Email",
                    sortField: "email_address",
                    titleClass: "",
                    dataClass: ""
                },
                {
                    name: "acl_name",
                    title: "Role",
                    sortField: "acl_name",
                    titleClass: "",
                    dataClass: ""
                },
                {
                    name: "activation_date",
                    title: "Activated On",
                    sortField: "activation_date",
                },
                {
                    name: "created_at",
                    title: "Created At",
                    sortField: "created_at",
                    callback: "createdAt"
                }
            ],
            range: "",
            search_match: "",
            loadOnStart: true,
            sortOrder: [{
                field: "created_at",
                direction: "desc"
            }],
            is_partial_resulting: false,

            moreParams: {
                start: "",
                filter: "",
                end: ""
            }
        };
    },

    mounted() {

        var vm = this;
        if (vm.$cookies.get("role_id") != 1 && vm.$cookies.get("role_id") != 2) {
            vm.$router.push({
                name: "dashboard"
            });
        }

        var start = moment().subtract(120, "days");
        var end = moment();

        function cb(start, end) {
            vm.dateFilter(start.format("YYYY-MM-DD"), end.format("YYYY-MM-DD"));
            $('input[name="dates"]').val(
                start.format("D MMMM, YYYY") + " - " + end.format("D MMMM, YYYY")
            );
        }

        $('input[name="dates"]').daterangepicker({
                startDate: start,
                endDate: end,
                ranges: {
                    Today: [moment(), moment()],
                    Yesterday: [
                        moment().subtract(1, "days"),
                        moment().subtract(1, "days")
                    ],
                    "Last 7 Days": [moment().subtract(6, "days"), moment()],
                    "Last 30 Days": [moment().subtract(29, "days"), moment()],
                    "This Month": [moment().startOf("month"), moment().endOf("month")],
                    "Last Month": [
                        moment()
                        .subtract(1, "month")
                        .startOf("month"),
                        moment()
                        .subtract(1, "month")
                        .endOf("month")
                    ]
                }
            },
            cb
        );

        cb(start, end);
    },

    watch: {
        data(newVal, oldVal) {
            this.$refs.vuetable.refresh();
        },
        range() {
            var start = this.range[0];
            var end = this.range[1];
            start = moment(start).format("YYYY-MM-DD");
            end = moment(end).format("YYYY-MM-DD");
            this.moreParams.start = start;
            this.moreParams.end = end;
            this.$refs.vuetable.refresh();
        }
    },

    methods: {
        dateFilter: function (start, end) {
            var vm = this;

            vm.start = start;
            vm.end = end;

            vm.moreParams.start = start;
            vm.moreParams.end = end;

            this.$refs.vuetable.refresh();

            console.log("start date filter", start);
            console.log("end date filter ", end);
        },
        createdAt: function (value) {
            if (!value) {
                return "-";
            } else {
                return moment(value).format("h:mm a,DD MMM YYYY");
            }
        },

        searchRecord: function () {
            this.loadRecord = true;
            var str = this.search_match;
            var newString = str.indexOf("0") == 0 ? str.substring(1) : str;
            this.moreParams.filter = "254" + newString;
            this.$refs.vuetable.refresh();
        },

        dataManager(sortOrder, pagination) {
            if (this.data.length < 1) return;

            let local = this.data;

            // sortOrder can be empty, so we have to check for that as well
            if (sortOrder.length > 0) {
                console.log("orderBy:", sortOrder[0].sortField, sortOrder[0].direction);
                local = _.orderBy(
                    local,
                    sortOrder[0].sortField,
                    sortOrder[0].direction
                );
            }

            pagination = this.$refs.vuetable.makePagination(
                local.length,
                this.perPage
            );
            console.log("pagination:", pagination);
            let from = pagination.from - 1;
            let to = from + this.perPage;

            return {
                pagination: pagination,
                data: _.slice(local, from, to)
            };
        },

        onPaginationData(paginationData) {
            this.$refs.paginationInfo.setPaginationData(paginationData);
            this.$refs.pagination.setPaginationData(paginationData);
        },

        onChangePage(page) {
            this.$refs.vuetable.changePage(page);
        },
        onLoading() {
            this.loading = true;
            console.log("loading... show your spinner here");
        },
        onLoaded() {
            this.loading = false;
            console.log("loaded! .. hide your spinner here");
            $(".ui.dropdown").dropdown();
        }
    }
};
</script>
